import { cn } from '@/utils/cn';
import { journalReadHtml } from '@/lib/journal/journalReadContent';
import { sanitizeJournalHtml } from '@/lib/journal/journalRichText';
import { MarkdownView } from './MarkdownView';

const FORMATTED_CLASS = cn(
  'journal-formatted-view max-w-none text-ds-text-2',
  '[&_h1]:mb-2 [&_h1]:mt-3 [&_h1]:text-lg [&_h1]:font-semibold [&_h1]:text-ds-text',
  '[&_h2]:mb-2 [&_h2]:mt-3 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-ds-text',
  '[&_p]:mb-2 [&_p]:leading-relaxed',
  '[&_ul]:mb-2 [&_ul]:list-disc [&_ul]:pl-5',
  '[&_ol]:mb-2 [&_ol]:list-decimal [&_ol]:pl-5',
  '[&_li]:mb-0.5',
  '[&_strong]:font-semibold [&_em]:italic [&_u]:underline',
);

interface JournalFormattedViewProps {
  html?: string | null;
  text: string;
  className?: string;
  variant?: 'default' | 'read';
}

export function JournalFormattedView({
  html,
  text,
  className,
  variant = 'default',
}: JournalFormattedViewProps) {
  if (variant === 'read') {
    const read = journalReadHtml(html, text);
    if (!read.html) return null;
    return (
      <div
        className={cn('jf-tx', className)}
        // HTML is sanitized with a strict allowlist in journalReadHtml.
        dangerouslySetInnerHTML={{ __html: read.html }}
      />
    );
  }

  const sanitized = sanitizeJournalHtml(html);
  if (sanitized) {
    return (
      <div
        className={cn(FORMATTED_CLASS, className)}
        // HTML is sanitized with a strict allowlist immediately above.
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    );
  }
  return <MarkdownView content={text} className={className} />;
}
